"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChooseUpgradeRole = void 0;
const react_1 = __importDefault(require("react"));
const theme_1 = require("../utils/theme");
const css_manager_1 = require("@food/css-manager");
const Button_1 = require("@food/ui/build/dist/src/Button");
const style = (0, css_manager_1.registerClass)((theme, sc) => `
	padding-top: ${theme.ratios.l * theme.font.baseSize}px;
	padding-bottom: ${theme.ratios.l * theme.font.baseSize}px;
	
	.${sc('role')} {
		margin-top: ${theme.ratios.s * theme.font.baseSize}px;
	}
`);
/**
 * Componente utilizzato per mostrare un messaggio all'utente consumer che desidera fare l'upgrade di ruolo
 */
const ChooseUpgradeRole = ({ t, upgrade, close, }) => {
    const intro = t('upgrade role introduction html');
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("h2", null, t `Upgrade role`),
        react_1.default.createElement("section", { className: style },
            intro !== '' && (react_1.default.createElement("div", { dangerouslySetInnerHTML: { __html: intro } })),
            react_1.default.createElement(Button_1.Button, { label: t `Upgrade to Professional`, onClick: upgrade, block: true, className: (0, css_manager_1.subClass)(style, 'role'), type: 'success' }),
            react_1.default.createElement("div", { className: theme_1.footer },
                react_1.default.createElement(Button_1.Button, { label: t `Close`, onClick: () => close() })))));
};
exports.ChooseUpgradeRole = ChooseUpgradeRole;
//# sourceMappingURL=ChooseUpgradeRole.js.map